// extracted by mini-css-extract-plugin
export var container = "_92-0";
export var containerTopRight = "_92-1";